import React from 'react';

const Home = () => (
  <div className="pageContainer text-center">
    <h2 className="p-2" style={{ fontWeight: 'bold' }}>Welcome to our page</h2>
    <div>
      Math Magicians is a website for all fans of mathematics.
      Make simple calculations and view some of your favorite math quotes!
    </div>
  </div>
);

export default Home;
